import PageHeader from '@/app/modules/_shared/layout/header/components/page-header/page-header.vue';
import MobileMenuButton from '@/app/modules/_shared/layout/header/components/mobile-menu-button/mobile-menu-button.vue';

export default {
  name: 'header-container',
  components: {
    PageHeader,
    MobileMenuButton,
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showMobileMenu() {
      return this.$store.getters['layout/showMobileMenu'];
    },
  },
};
